import { render, staticRenderFns } from "./RevisionNacedora.vue?vue&type=template&id=187c174a"
import script from "./RevisionNacedora.vue?vue&type=script&lang=js"
export * from "./RevisionNacedora.vue?vue&type=script&lang=js"
import style0 from "./RevisionNacedora.vue?vue&type=style&index=0&id=187c174a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports